import React from "react";
import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import { DocIcon } from "../../assets/svgs/Icons";
import isAllowed from "../../routing/isAllowed";


function AddNonCertStock() {
  return (
    <Box marginBottom={"3rem"}>
      <Grid templateColumns="repeat(3, 1fr)" marginTop={"5rem"} marginLeft={"2rem"}>
        <GridItem>
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Add Non-Certified Stock
          </Text>
          <Text color={" #3958DC"} fontSize="sm">
            Please fill necessary details
          </Text>
        </GridItem>
        {/* <GridItem>
            <Input bgColor="white" placeholder="search" />
          </GridItem>
          <GridItem ml={"20"}>
            <Button bg={"#52BBFF"} color={"#fff"} w="130px">
              Add
            </Button>
          </GridItem> */}
      </Grid>
      <Box
        marginTop={"3.3rem"}
        bg={"#52BBFF"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
      >
        Non-certified Stock
      </Box>
      <Box mt="5">
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Description*
            </Text>
            <Input
              type="tel"
              color={"#B8DEF8"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              placeholder="Viscose"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Company Name*
            </Text>
            <Input
              type="tel"
              color={"#B8DEF8"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              placeholder="Dean Dayal Ichalkaranji"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box mt="5">
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Category
            </Text>
            <Select bgColor="white" color={" #464C64"} fontSize="sm" w="80%" marginTop="10px">
              <option>Men’s Apparel</option>
              <option>Women’s Apparel</option>
            </Select>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Details
            </Text>
            <Input
              type="tel"
              color={"#B8DEF8"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              placeholder="20% Viscose"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box mt="5">
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Composition
            </Text>
            <Flex alignItems={"center"} gap={"2rem"}>
              <Select
                _placeholder={{
                  opacity: 1,
                  color: " #464C64",
                  fontSize: "14px",
                }}
                w="30%"
                placeholder="FIbre 1"
                color={"#464C64"}
                marginTop="10px"
                bg={"#fff"}
              >
                <option value="option1">Option 1</option>
                <option value="option2">Option 2</option>
                <option value="option3">Option 3</option>
              </Select>
              <Button
                w="120px"
                bg="#52BBFF"
                color={"#fff"}
                _hover={{ bg: "#52BBFF" }}
                mt="10px"
              >
                <DocIcon width="25px" height="25px" />
              </Button>
            </Flex>
          </GridItem>
          {/* <GridItem>
                <Button
                  w="120px"
                  bg="#52BBFF"
                  color={"#fff"}
                  _hover={{ bg: "#52BBFF" }}
                >
                  <DocIcon width="25px" height="25px" />
                </Button>
            </GridItem> */}
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Additional Claim
            </Text>
            <Select
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
              placeholder="Recycled"
              color={" #464C64"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
            >
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
            </Select>
          </GridItem>
        </Grid>
      </Box>

      <Box mt="5">
        <Grid marginTop={"1rem"} marginLeft={"2rem"}>

          <GridItem mt={"0rem"}>

            <Input
              type="number"
              color={"#B8DEF8"}
              marginTop="10px"
              bg={"#fff"}
              w="15%"
              placeholder="60%"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box mt="5">
        <Grid templateColumns="0.5fr 0.5fr 1fr" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Quantity
            </Text>
            <Input
              type="number"
              color={"#B8DEF8"}
              marginTop="10px"
              bg={"#fff"}
              w="60%"
              placeholder="100"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              UOM
            </Text>
            <Input
              type="number"
              color={"#B8DEF8"}
              marginTop="10px"
              bg={"#fff"}
              w="60%"
              placeholder="KG"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Transportation Details
            </Text>
            <Input
              type="number"
              color={"#B8DEF8"}
              marginTop="10px"
              bg={"#fff"}
              w="80%"
              placeholder="Road"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box mt="5">
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Date
            </Text>
            <Input
              type="tel"
              color={"#B8DEF8"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              placeholder="12/12/22"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Time
            </Text>
            <Input
              type="tel"
              color={"#B8DEF8"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              placeholder="12:38PM"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box mt="5">
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Organisational unit
            </Text>
            <Input
              type="tel"
              color={"#B8DEF8"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              placeholder="003"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              GST Number
            </Text>
            <Input
              type="tel"
              color={"#B8DEF8"}
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              placeholder="GSTIN09123485"
              fontSize={"14px"}
              _placeholder={{
                opacity: 1,
                color: " #464C64",
                fontSize: "14px",
              }}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box mt="5">
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem>
            <Box>
              <Button
                w="150px"
                bg="#52BBFF"
                color={"#fff"}
                _hover={{ bg: "#52BBFF" }}
              >
                Add
              </Button>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  );
}

export default isAllowed(AddNonCertStock)
